import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Alert, Button, Card, Row, Col, Form, Spinner } from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import logo from "../../images/logo2.png";
import {
  editEvaluationAccept,
  getEvaluationAccept,
  saveEvaluationAccept,
} from "../../redux/evaluacion_desempenio/EvaluationAccept/actions";

const EvaluationAccepted = (props) => {
  const [validated, setValidated] = useState(false);
  const [comentario, setComentario] = useState("");

  const dispatch = useDispatch();

  const { loading, formError, evaluationAccept } = useSelector(
    (store) => store.evaluationAccept
  );

  const fechaActual = new Date();

  const schemaAcceptEvaluation = Yup.object().shape({
    comentario: Yup.string().required("**Campo requerido"),
  });

  useEffect(() => {
    dispatch(getEvaluationAccept(props.match.params.token));
  }, [props.match.params.token]);

  const onSubmit = async (req) => {
    let _req = {
      comentario_factor: req.comentario,
      comentario_competencia: req.comentario,
      aceptacion: parseInt(props.match.params.idEncabezado),
      respuesta: true,
    };
    setComentario(req.comentario);
    dispatch(saveEvaluationAccept(_req, props.match.params.token));
  };

  return (
    <>
      <div className="colorFondoAceptacion d-flex justify-content-between align-items-center py-3">
        <Col
          className="d-flex justify-content-start align-items-center"
          style={{ position: "absolute", bottom: "78%", top: "5%" }}
        >
          <img
            src={logo}
            style={{
              width: "200px",
              marginLeft: "1rem",
            }}
            alt="Logo"
          />
        </Col>
        <div className="contenedor">
          <Col
            className="shadowEval divEvaluacion border border-muted rounded px-0"
            xl={6}
            lg={9}
            md={9}
            sm={10}
            xs={10}
            style={{ minHeight: "45%" }}
          >
            {/* <Card style={{ border: "none" }}> */}
            <Card.Header>
              <b>Aceptación Evaluación del desempeño</b>
            </Card.Header>
            {/* <Card.Body> */}
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              // evaluationAccept && (
              //   <>
              <Formik
                validationSchema={schemaAcceptEvaluation}
                onSubmit={onSubmit}
                initialValues={{
                  comentario: comentario,
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  // setFieldValue,
                  handleBlur,
                  values,
                  touched,
                  // isValid,
                  errors,
                }) => (
                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    validated={validated}
                  >
                    {!!formError && comentario === "" && (
                      <Alert variant="danger" className="my-3 mx-4 ">
                        {formError}
                      </Alert>
                    )}
                    {comentario !== "" && (
                      <Alert variant="info" className="my-3 mx-4 ">
                        Muchas gracias, hemos recibido tu comentario.
                      </Alert>
                    )}
                    <div className="mt-3 mb-4 mx-4 border-left border-info rounded">
                      <Alert variant="light">
                        <p>
                          Yo,{" "}
                          {evaluationAccept
                            ? evaluationAccept.nombre
                            : "nombre colaborador"}
                          , después de haber leído, entendido y revisado con mi
                          jefe la evaluación del desempeño. Envió esta
                          evaluación a los {moment(fechaActual).format("DD")}{" "}
                          del {moment(fechaActual).format("MM")} del{" "}
                          {moment(fechaActual).format("YYYY")} como señal de
                          acuerdo mutuo al resultado obtenido.
                        </p>
                      </Alert>
                    </div>
                    <Form.Group as={Row} className="mx-2">
                      <Col>
                        <Row>
                          <Col>
                            <Form.Control
                              id="comentario"
                              name="comentario"
                              isInvalid={
                                touched.comentario && errors.comentario
                              }
                              isValid={touched.comentario && !errors.comentario}
                              onBlur={handleBlur("comentario")}
                              onChange={handleChange}
                              value={values.comentario}
                              className="rounded"
                              as="textarea"
                              placeholder=""
                              style={{ resize: "none" }}
                              rows={7}
                              disabled={!!formError}
                            ></Form.Control>
                            {touched.comentario && errors.comentario && (
                              <div>
                                <small className="text-danger mx-2">
                                  {errors.comentario}
                                </small>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Form.Group>
                    <Col className="mt-5 mb-2 d-flex justify-content-end align-items-center">
                      {!!formError ? null : (
                        <Button
                          className="rounded-pill"
                          variant="secondary"
                          type="submit"
                        >
                          Enviar
                        </Button>
                      )}
                    </Col>
                  </Form>
                )}
              </Formik>
              //   </>
              // )
            )}
            {/* {evaluationAcceptError !== "" && !loading && (
            <Alert variant="danger" className="m-3">
              {evaluationAcceptError}
            </Alert>
          )} */}
            {/* </Card.Body> */}
            {/* </Card> */}
          </Col>
        </div>
      </div>
    </>
  );
};

export default EvaluationAccepted;
